import { Paper, styled } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import Image from '../../atoms/Image';
import plusgradeAssets from '../../configs/plusgradeAssets';
import Typography from '../../atoms/Typography';

const StyledFooter = styled(Paper)`
  margin-top: 3rem;
  padding: 1.5rem 1rem;
`;

const Link = styled('a')`
  color: #000;
  :hover {
    color: blue;
  }
`;

const PlugradeLogo = styled(Image)`
  img {
    width: 150px;
    max-width: 30vw;
  }
`;

export const makeDataTestId = (dataTestId = 'error-footer') => {
  return {
    prefix: dataTestId,
    wrapper: `${dataTestId}.wrapper`,
    faqUrl: `${dataTestId}.text`,
    termsUrl: `${dataTestId}.button`,
  };
};

interface ErrorFooterProps {
  dataTestId?: string;
}

const ErrorFooter: React.FC<ErrorFooterProps> = ({ dataTestId }) => (
  <StyledFooter elevation={0} square data-testid={makeDataTestId(dataTestId).wrapper}>
    <Grid container spacing={2} alignItems="flex-end">
      <Grid xs={12} md={4}>
        <Typography color="text.primary" variant="body1" align="left">
          <Link href={''} data-testid={makeDataTestId(dataTestId).faqUrl}>
            FAQ
          </Link>{' '}
          &#8226;{' '}
          <Link href={''} data-testid={makeDataTestId(dataTestId).termsUrl}>
            {'Terms and conditions'}
          </Link>
        </Typography>
      </Grid>
      <Grid
        xs={6}
        md={4}
        container
        spacing={0}
        alignItems={{ xs: 'flex-start', md: 'center' }}
        direction="column"
        justifyContent="flex-end"
      >
        <Typography variant="body2" color="text.secondary">
          {'powered by:'}
        </Typography>
        <PlugradeLogo src={plusgradeAssets.logo} alt="Plusgrade logo" />
      </Grid>
      <Grid xs={6} md={4}>
        <Typography variant="body1" color="text.primary" align="right">
          © {new Date().getFullYear()} {'Plusgrade'}
        </Typography>
      </Grid>
    </Grid>
  </StyledFooter>
);

export default ErrorFooter;
